<div class="map-title">{{title}}</div>
<div id="map-{{id}}"></div>
<div class="stations-access-toggle">
  <div class="form-check form-check-inline">
    <input type="checkbox" name="stations_public" id="stations_public" value="1" checked="checked" class="form-check-input" />
    <label class="form-check-label" for="stations_public">Public {{station_label}}</label>
  </div>
  <div class="form-check form-check-inline">
    <input type="checkbox" name="stations_private" id="stations_private" value="1" class="form-check-input" />
    <label class="form-check-label" for="stations_private">Private {{station_label}}</label>
  </div>
</div>
